module.exports = __webpack_public_path__ + "img/EmojiEmotionsOutlined.a6009a3e.svg";